import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import './LargeIconButton.scss';

export const LargeIconButton = ({
  Icon,
  content,
  disabled,
  isLoading,
  type = 'black', // 'black' | 'red' | 'green' | 'gray'
  tooltip,
  onClick,
  className = '',
  btnRef,
}) => {
  return (
    <button
      className={cx('large-icon-button', type, { loading: isLoading, [className]: !!className })}
      disabled={disabled || isLoading}
      data-tooltip-id={tooltip?.id ? tooltip.id : null}
      data-tooltip-content={tooltip?.title ? tooltip.title : null}
      data-tooltip-place={tooltip?.place ? tooltip.place : 'top'}
      onClick={onClick}
      ref={btnRef}
    >
      {isLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        <>
          {Icon && <Icon />}
          {content}
        </>
      )}
    </button>
  );
};
